// ============================================================================
// STATUS MACHINE — Personal Finance V2 (Blueprint §7)
// Transições válidas de status para lançamentos financeiros pessoais.
// Pure JS — sem dependência de React/Firebase.
// ============================================================================

export const STATUS = Object.freeze({
    PENDING:   'PENDING',
    PAID:      'PAID',
    FORECAST:  'FORECAST',
    CANCELLED: 'CANCELLED',
});

export const TRANSITION = Object.freeze({
    CREATE:  'CREATE',
    SETTLE:  'SETTLE',
    REVERT:  'REVERT',
    CANCEL:  'CANCEL',
    EDIT:    'EDIT',
});

// Mapa de transições permitidas: { [statusAtual]: [statusesAlvo] }
const ALLOWED = {
    [STATUS.PENDING]:   [STATUS.PAID, STATUS.CANCELLED],
    [STATUS.PAID]:      [STATUS.PENDING, STATUS.CANCELLED],
    [STATUS.FORECAST]:  [STATUS.PENDING, STATUS.CANCELLED],
    [STATUS.CANCELLED]: [STATUS.PENDING],
};

/**
 * Verifica se a transição from → to é válida.
 * @param {string} from — status atual (ou null para criação)
 * @param {string} to — status alvo
 * @returns {{ valid: boolean, transition: string|null, error: string|null }}
 */
export function canTransition(from, to) {
    // Criação (doc novo)
    if (from == null) {
        if ([STATUS.PENDING, STATUS.PAID, STATUS.FORECAST].includes(to)) {
            return { valid: true, transition: TRANSITION.CREATE, error: null };
        }
        return { valid: false, transition: null, error: `Criação com status '${to}' não é permitida.` };
    }

    // Mesma coisa = sem transição (EDIT puro)
    if (from === to) {
        return { valid: true, transition: TRANSITION.EDIT, error: null };
    }

    const targets = ALLOWED[from];
    if (!targets || !targets.includes(to)) {
        return { valid: false, transition: null, error: `Transição '${from}' → '${to}' não é permitida.` };
    }

    // Determina o tipo de transição
    let transition = TRANSITION.EDIT;
    if (to === STATUS.PAID) transition = TRANSITION.SETTLE;
    if (to === STATUS.CANCELLED) transition = TRANSITION.CANCEL;
    if (from === STATUS.PAID && to === STATUS.PENDING) transition = TRANSITION.REVERT;
    if (from === STATUS.CANCELLED && to === STATUS.PENDING) transition = TRANSITION.REVERT;

    return { valid: true, transition, error: null };
}

/**
 * Fase 3 — Guard: PAID requer settlementDate.
 * Chamado ANTES de persistir qualquer status=PAID.
 * @param {string} targetStatus
 * @param {string|null|undefined} settlementDate — YYYY-MM-DD ou ISO string
 * @returns {{ ok: boolean, error: string|null }}
 */
export function validateSettlement(targetStatus, settlementDate) {
    if (targetStatus !== STATUS.PAID) return { ok: true, error: null };
    if (!settlementDate) {
        return { ok: false, error: 'Status PAID requer settlementDate preenchido.' };
    }
    return { ok: true, error: null };
}
